module.exports = __webpack_public_path__ + "img/phone-shadow-large.00ee0f39.png";